import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";

export default function ProductCard({ product }) {
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid="product-card"
      className="group flex flex-col bg-white border border-[#E5E2DC] hover:border-[#A66E4E] transition-colors"
    >
      <div className="aspect-[4/3] bg-[#EFECE6] overflow-hidden border-b border-[#E5E2DC]">
        {product.image_url ? (
          <img
            src={product.image_url}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#6E6B65] eyebrow">
            no image
          </div>
        )}
      </div>
      <div className="p-4 flex flex-col gap-2 flex-1">
        <div className="flex items-center justify-between">
          <span className="eyebrow text-[9px]">{product.brand}</span>
          <span className="text-[10px] uppercase tracking-wider text-[#6E6B65]">
            {product.category}
          </span>
        </div>
        <h3 className="font-accent italic text-xl leading-tight text-[#1C1B1A]">
          {product.name}
        </h3>
        <p className="text-[12.5px] text-[#6E6B65] leading-snug line-clamp-2 flex-1">
          {product.description}
        </p>
        <div className="flex items-center justify-between pt-2 border-t border-[#E5E2DC] mt-2">
          <span className="text-[11px] font-mono text-[#6E6B65]">
            {product.launch_year || ""}
          </span>
          <span className="flex items-center gap-1 text-[11px] uppercase tracking-wider font-semibold text-[#A66E4E] group-hover:gap-2 transition-all">
            inspect <ArrowUpRight size={12} weight="bold" />
          </span>
        </div>
      </div>
    </Link>
  );
}
